import { Tab, Tabs } from "react-bootstrap";
import { useRef } from "react";
import { useSearchParams } from "react-router-dom";

import { GovPlanMetricsChart } from "./components/chart";
import { ListSecretary } from "./components/list";
import {
    UpsertSecretaryModal,
    UpsertSecretaryModalHandles,
} from "./components/upsert/upsert";

export const GovPlanDashboard = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const ref = useRef<UpsertSecretaryModalHandles>(null);

    const handleOnClick = (tab: string | null) => {
        const draft = new URLSearchParams(searchParams);
        draft.set("tab", tab ?? "metrics");
        setSearchParams(draft);
    };

    return (
        <>
            <header className="w-full h-28 border-b border-slate-500 flex justify-between">
                <h5 className="text-slate-700 pt-5 pl-4">Plano de governo</h5>

                <section className="self-end flex space-x-4">
                    <button
                        type="button"
                        onClick={() => ref.current?.open()}
                        className="btn-primary mb-2"
                    >
                        Cadastrar
                    </button>
                </section>
            </header>
            <Tabs
                defaultActiveKey={searchParams.get("tab") || "metrics"}
                transition={false}
                className="my-4"
                onSelect={handleOnClick}
            >
                <Tab eventKey="metrics" title="Métricas">
                    <GovPlanMetricsChart />
                </Tab>
                <Tab eventKey="list" title="Listagem">
                    <ListSecretary />
                </Tab>
            </Tabs>
            <UpsertSecretaryModal ref={ref} />
        </>
    );
};
